/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { LinkBase } from "@quintype/components";
import get from "lodash.get";
import PropTypes from "prop-types";
import { getTextColor, generateNavigateSlug } from "../../../utils/utils";
import "./load-more.m.css";

export const LoadmoreButton = ({
  config,
  collection,
  template = "SubsequentLoadCount",
  onClick,
  navigate,
  qtConfig
}) => {
  const showButton = get(config, ["showButton"], true);
  const btnText = get(config, ["buttonText"], "Read More");
  const theme = get(config, ["theme"], "");
  const textColor = getTextColor(theme);

  const slug = generateNavigateSlug(collection, qtConfig);

  if (!showButton) return null;

  return template === "SubsequentLoadCount" ? (
    <div className="arr--button" styleName={`button ${textColor} default`} onClick={onClick}>
      {btnText}
    </div>
  ) : (
    <LinkBase href={slug} navigateTo={navigate}>
      <div className="arr--button" styleName={`button ${textColor} default`}>
        {btnText}
      </div>
    </LinkBase>
  );
};

LoadmoreButton.propTypes = {
  collection: PropTypes.object,
  template: PropTypes.string,
  config: PropTypes.object,
  onClick: PropTypes.func,
  navigate: PropTypes.func,
  qtConfig: PropTypes.object
};
